import BonusStyles from "@/base/styles/Bonus.module.scss";
import Image from "next/image";
import {Money} from "@/base/utils/money";
import React from "react";
import TopUpReward from "@/base/types/Cart/TopUpReward";
import {useTranslation} from "next-i18next";
import {useUser} from "@/base/components/auth/UserProvider";
import {PiSealQuestionBold} from "react-icons/pi";

const rewards = [
	[2],
	[2],
	[3],
	[4],
	[5, 6],
]

export const TopupBonus = ({bonus, i, to, lastFrom, wasProgress, className, animate}: { bonus: TopUpReward, i: number, to: number, lastFrom: number, wasProgress: boolean, className?: string, animate?: boolean }) => {
	const {t} = useTranslation();
	const UserContext = useUser();

	const percentage = Math.round(bonus.percentage * 100);
	const from = lastFrom;
	const level = i + 1;
	const isDisabled = wasProgress;
	const isObtained = percentage >= 100;
	const inProgress = percentage > 0 && percentage < 100 && !isDisabled;

	return (
		<div className={`${!BonusStyles[`level_${level}`]} ${inProgress && animate && BonusStyles[`level_activate`]} relative ${isDisabled && `saturate-[30%] brightness-[96%]`} ${className || ''}`}>
			<div className={`absolute right-0 top-0 mt-6 mr-4`}>
				{isDisabled ? <>
					<PiSealQuestionBold size={70}/>
				</> : <>
					<Image
						src={`/base/image/topup-bonuses/${level}.png`}
						alt={t('base-dashboard-promo:topup-rewards.level-base.subname', {level})}
						width={70}
						height={70}
					/>
				</>}
			</div>
			<div className={`flex flex-col gap-2 relative`}>
				<p className={`text-2xl font-semibold text-text-2`}>{t(`base-dashboard-promo:topup-rewards.level.${level}.name`)}</p>
				<p className={`text-text-2 font-medium`}>{t('base-dashboard-promo:topup-rewards.level-base.subname', {level})}</p>
				<p className={`text-text-2 text-lg font-bold`}>
					{isDisabled ? (
						<>
							???-???
						</>
					) : (
						<>
							{Money.format(Math.round(from), UserContext.currency)}
							<span>-</span>
							{Money.format(Math.round(to), UserContext.currency)}
						</>
					)}
				</p>
				<div className={`flex flex-col gap-1`}>
					<p className={`font-extrabold font-montserrat-alternates text-primary`}>%{percentage}</p>
					<div className={`h-[13px] bg-gray-200 dark:bg-gray-400 overflow-hidden rounded-xl`}>
						<div className={`bg-primary h-full`} style={{
							width: `${percentage}%`,
						}}></div>
					</div>
				</div>
				<ul className={`ml-4 text-gray-400 text-sm`}>
					<li>
						{t(`base-dashboard-promo:topup-rewards.level-bonus.1`)} {Money.format(Math.round(bonus.take), UserContext.currency)}
					</li>
					{rewards[i].map((v, k) => (
						<li key={k}>
							{t(`base-dashboard-promo:topup-rewards.level-bonus.${v}`)}
						</li>
					))}
				</ul>
			</div>
			{isDisabled && <div className={`absolute bg-base-bg/70 w-full h-full left-0 top-0`}/>}
		</div>
	)
}